import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import InternalLink from "~/components/Navigation/InternalLink";
import type { PermissionCheckProps } from "~/components/PermissionCheck/PermissionCheck";
import { Note } from "~/components/form";
import styles from "./ScriptModulesPreview.module.less";
import SelectScriptModules from "./SelectScriptModules";
import type { ScriptModule } from "./model";
export interface OpenScriptModulesDialogButtonProps {
    hasScriptModules: boolean;
    spaceId: string;
    projectId: string;
    permission?: PermissionCheckProps;
    onDataChanged: () => void;
}
export const OpenScriptModulesDialogButton: React.FC<OpenScriptModulesDialogButtonProps> = (props) => {
    //TODO OPS: permissions for runbooks
    const { hasScriptModules, permission = { permission: Permission.ProcessEdit, project: props.projectId, tenant: "*" } } = props;
    return (<OpenDialogButton label={hasScriptModules ? "Change" : "Include"} permission={permission}>
            <SelectScriptModules spaceId={props.spaceId} projectId={props.projectId} saveDone={() => props.onDataChanged()}/>
        </OpenDialogButton>);
};
OpenScriptModulesDialogButton.displayName = "OpenScriptModulesDialogButton"
export interface RenderScriptModulesActionsProps {
    hasScriptModules: boolean;
    includedScriptModules: ScriptModule[];
}
export interface ScriptModulesProps {
    spaceId: string;
    title?: React.ReactNode;
    includedScriptModules: ScriptModule[];
    renderActions: (renderProps: RenderScriptModulesActionsProps) => React.ReactNode;
}
export const ScriptModules: React.FC<ScriptModulesProps> = ({ spaceId, includedScriptModules, renderActions, title = <h4>Script Modules</h4> }) => {
    const hasScriptModules = includedScriptModules && includedScriptModules.length > 0;
    return (includedScriptModules && (<React.Fragment>
                {title}
                {hasScriptModules ? (<p className={styles.scriptModulesStatus}>Included script modules:</p>) : (<div>
                        <p>No script modules have been included</p>
                        <Note>
                            Modules can be created in the <InternalLink to={links.scriptModulesPage.generateUrl({ spaceId })}>Library</InternalLink>
                        </Note>
                    </div>)}
                <ul className={styles.includedScriptModules}>
                    {includedScriptModules.map((sm) => (<li key={sm.Id}>
                            <InternalLink to={links.editScriptModulePage.generateUrl({ spaceId, scriptModuleId: sm.Id })}>{sm.Name}</InternalLink>
                        </li>))}
                </ul>
                {renderActions({ hasScriptModules, includedScriptModules })}
            </React.Fragment>));
};
ScriptModules.displayName = "ScriptModules"
export interface ScriptModulesWithActionsProps {
    title?: React.ReactNode;
    spaceId: string;
    projectId: string;
    includedScriptModules: ScriptModule[];
    onDataChanged: () => void;
    renderActions?: (props: RenderScriptModulesActionsProps) => React.ReactNode;
}
export const ScriptModulesWithActions: React.FC<ScriptModulesWithActionsProps> = ({ includedScriptModules, onDataChanged, spaceId, projectId, title, renderActions = (props) => <OpenScriptModulesDialogButton hasScriptModules={props.hasScriptModules} spaceId={spaceId} projectId={projectId} onDataChanged={onDataChanged}/>, }) => {
    return <ScriptModules spaceId={spaceId} title={title} renderActions={renderActions} includedScriptModules={includedScriptModules}/>;
};
ScriptModulesWithActions.displayName = "ScriptModulesWithActions"
